export default __webpack_public_path__ + "static/media/referral.bf1cc111.png";